/**
 * PaymentActionCreator - Dweb
 */

import * as constants from "../constants";
import * as logger from '../../logger';


export const getSubscriptionPlans = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/subscription/plans`,
        success: (response) => populateSubscriptionPlans(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getPaymentLink = (orderId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/subscription/pending/${orderId}`,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getPlansAfterCouponApply = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/subscription/order-amount`,
        data: data,
        success: (response) => populateSubscriptionPlans(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const populateSubscriptionPlans = (response) => {
    var payloadData = []
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response
    } else {
    }
    return { type: constants.GET_SUBSCRIPTION_PLAN, payload: payloadData };
}


export const paySubscriptionAction = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/subscription/order`,
        data: data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const processUselessData = (response) => {
    logger.log("Subscritption action creator", response);
    return { type: null, payload: null }
}
export const updateFreeTrialModal = (value) => {
    return { type: constants.UPDATE_FREE_TRIAL_MODAL, payload: value }
}
export const updatePaymentFailedModal = (value) => {
    return { type: constants.UPDATE_PAYMENT_FAILED_MODAL, payload: value }
}


export const getSubscriptionStatus = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/subscription/status`,
        success: (response) => processSubscriptionStatusData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const processSubscriptionStatusData = (response) => {
    var payloadData = {}
    if (response.status && response.status.code && response.status.code === 200) {
        payloadData = response.response
        /*if (payloadData && 
            payloadData.status && 
            payloadData.subscriptionType && 
            payloadData.status=="ACTIVE" && 
            payloadData.subscriptionType ==="FREE_TRIAL" ) {
                payloadData.freeTrial=true;
        }else{
            payloadData.freeTrial=false;
        }*/
        if (payloadData
            && (typeof payloadData.numberOfDays != 'undefined' || payloadData.numberOfDays != null)
            && (payloadData.numberOfDays <= 10 || payloadData.numberOfDays === 0)
            && payloadData.orderId == null) {
            payloadData.freeTrial = true;
        } else {
            payloadData.freeTrial = false;
        }
        if (payloadData &&
            payloadData.status &&
            payloadData.subscriptionType &&
            payloadData.orderId != null &&
            payloadData.status === "PROCESSING" &&
            payloadData.subscriptionType === "PAID") {
            payloadData.paymentFailed = true;
        }else if (payloadData &&
            payloadData.status &&
            payloadData.subscriptionType &&
            payloadData.orderId === null &&
            payloadData.status === "PROCESSING" &&
            (typeof payloadData.numberOfDays != 'undefined' || payloadData.numberOfDays != null)
            && payloadData.numberOfDays > 0 &&
            payloadData.subscriptionType === "PAID") {
            payloadData.paymentFailed =false;
            payloadData.status = "ACTIVE";
        } else if (payloadData &&
            payloadData.status &&
            payloadData.subscriptionType &&
            payloadData.orderId != null &&
            payloadData.status === "EXPIRED" &&
            payloadData.subscriptionType === "PAID") {
            payloadData.paymentFailed = true;
        } else {
            payloadData.paymentFailed = false;
        }
    } else {
        payloadData.freeTrial = false;
        payloadData.paymentFailed = false;
    }
    return { type: constants.GET_SUBSCRIPTION_STATUS, payload: payloadData };
}

export const freeTrailShown = (value) => {
    return{ type: constants.FREE_TRAIL_SHOWN , payload: value }
}